import defaultTheme from './defaultTheme';
const bnplTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#0472ae', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#0472ae', background: '#0472ae' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#0472ae' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#0472ae', border: '#0472ae', background: '#0472ae' }), field: {
        focus: '#0472ae',
        label: '#0472ae',
        icon: '#0472ae',
    } });
export default bnplTheme;
